/**
 * Put here anything that we need to setup in global window environment
 * Currently we need this because of some limitation on the MF apps in general
 * To have a single instance of anything, we cannot just use import(...)
 * Therefore, We use the window instance instead
 *
 * DO NOT MODIFY window.__* directly, use this unsafeAccessor
 * so that we can have a single point of entry.
 */

import type { Globals } from '../types/globals';

window['__MF_GLOBALS__'] = window['__MF_GLOBALS__'] || {};
let __MF_GLOBALS__: Globals = window['__MF_GLOBALS__'];

export function setUnsafeGlobalInstance<T extends keyof Globals>(
  key: T,
  singleton: Globals[T]
) {
  // Can only be initialized once
  if (
    window !== undefined &&
    window['__MF_GLOBALS__'] &&
    !window['__MF_GLOBALS__'][key]
  ) {
    console.log('Setup global instance inside window.__MF_GLOBALS__', key);

    // Update __MF_GLOBALS__ incase window is being updated elsewhere.
    __MF_GLOBALS__ = window['__MF_GLOBALS__'];
    __MF_GLOBALS__[key] = singleton;

    window['__MF_GLOBALS__'] = __MF_GLOBALS__;

    return true;
  }

  return false;
}

export function getUnsafeGlobalInstance<T extends keyof Globals>(key: T) {
  if (window['__MF_GLOBALS__']?.[key]) {
    return window['__MF_GLOBALS__'][key] as Exclude<Globals[T], undefined>;
  }

  throw new Error("Global instance hasn't been setup");
}
